/* THE JADE MOMENT:进入视口后自动擦膜揭示 + 抛光高光 */
(function () {
  var sec = document.getElementById('jade-moment');
  if (!sec) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { sec.classList.add('is-revealed'); return; }
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      io.disconnect();
      sec.classList.add('is-revealing');
      setTimeout(function () { sec.classList.add('is-revealed'); }, 90);
      setTimeout(function () { sec.classList.remove('is-revealing'); }, 2200);
      setTimeout(function () {
        sec.classList.add('is-shining');
        setTimeout(function () { sec.classList.remove('is-shining'); }, 1500);
      }, 2000);
    });
  }, { threshold: 0.5 });
  io.observe(sec);
})();
